import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';


let language = localStorage.getItem('language');

if (language === undefined) {
    language = 'en';
}

i18n.use(initReactI18next).init({
    resources: {
        en: { translations: en },

    },
    fallbackLng: 'en',
    lng: 'en',
    // debug only when not in production
    debug: process.env.NODE_ENV !== 'production',
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false,
    interpolation: {
        escapeValue: false,
        formatSeparator: ',',
    },
    react: {
        wait: true,
    },
});

export default i18n;